"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable import/prefer-default-export, camelcase */
var combineLearningPanelUrl_1 = __importDefault(require("./combineLearningPanelUrl"));
var rest_1 = __importDefault(require("../../../rest"));
var assessmentsApi_1 = require("../../mock/learningPanel/assessmentsApi");
var AssessmentsAPIs = {
    getUncompletedAssessments: function () {
        return rest_1.default.get({
            mockFunc: function () { return assessmentsApi_1.mockUncompletedAssessment; },
            url: (0, combineLearningPanelUrl_1.default)('/assessments/uncompleted'),
        });
    },
    getAssessmentsResults: function () {
        return rest_1.default.get({
            mockFunc: function () { return assessmentsApi_1.assessmentsResults; },
            url: (0, combineLearningPanelUrl_1.default)('/assessments/results'),
        });
    },
};
exports.default = AssessmentsAPIs;
